<template>
    <el-container class="app-wrapper">
        <el-header class="fixed-header">
            <navheader />
        </el-header>
        <el-container class="main-container">
            <el-aside class="sidebar-container"
                      :class="[{'small-aside': collapseMenu}]">
                <sidebar class="menu-wrap" />
            </el-aside>
            <el-main>
                <app-main />
            </el-main>
        </el-container>

        <global-uploader v-if="isLogin" />

    </el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import globalUploader from '@/components/Uploader'
import { AppMain, Navheader, Sidebar } from './components'
export default {
    name: 'Layout',
    components: {
        AppMain,
        Navheader,
        Sidebar,
        globalUploader
    },
    computed: {
        ...mapGetters([
            'collapseMenu',
            'isLogin'
        ])
    }
}
</script>

<style lang="scss">
.app-wrapper {
    height: 100%;
    width: 100%;
    min-width: 1280px!important;
    overflow: auto;
    .el-header {
        padding: 0;
    }
    .fixed-header {
        height: 64px !important;
    }
    .sidebar-container {
        width: 180px !important;
        transition: width 0.5s;
        font-size: 0px;
        position: relative;
        flex-shrink: 0;
        box-shadow: 0 1px 4px 0 rgba(202, 202, 202, 0.5);
        overflow: auto;
    }
    .el-main {
        padding: 0;
        position: relative;
        margin-left: 1px;
    }
    .menu-wrap {
        width: 180px;
        background: #fff;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        overflow: auto;
        transition: width 0.5s;
    }
    .small-aside {
        width: 48px !important;
        .menu-wrap {
            width: 48px;
        }
    }
}
</style>
